import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import grievanceReducer from "./slices/grievanceSlice";
import statsReducer from "./slices/statsSlice";
import userReducer from "./slices/userSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    grievances: grievanceReducer,
    stats: statsReducer,
    users: userReducer,
  },
});

export default store;
